import { useConfiguracion } from '../../../metodos/ConfiguracionContext';
import { obtenerNombreEmpresaReal } from '../../../config/unificacion';
import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { useCorreosMarketingModel } from '../../../modelos/EmailMarkeeting/modeloCorreos';
import { useListasModel } from '../../../modelos/listas/modeloListas';
import WidgetPreviewPlantilla from './Visor/WidgetPreviewPlantilla';

const NuevaCampaña = ({ onCampanaCreada }) => {
  // 1. MODELOS Y CONTEXTOS EXISTENTES
  const { 
    campaignData, 
    setCampaignData, 
    destinatarios,
    Loadingdestinatarios,
    errordestinatarios,
    obtenerDestinatarios,

    plantillas,
    plantillasOptions,
    Loadingplantillas,
    errorplantillass,
    obtenerPlantillas,

    createCampana,
  } = useCorreosMarketingModel();

  const {
    universidadesOptions,
    cargarUniversidades,
    isLoadingUniversidad,
    carrerasOptions,
    cargarCarreras,
    isLoadingCarreras
  } = useListasModel();

  const { configuracion } = useConfiguracion();
  const nombreEmpresa = obtenerNombreEmpresaReal(configuracion.nombreEmpresa);

  // 2. NUEVOS ESTADOS PARA CARGAR PLANTILLAS DESDE POSTGRES
  const [plantillaSeleccionada, setPlantillaSeleccionada] = useState(null); // Guarda la plantilla activa para el preview

  const [contadorDestinatarios, setContadorDestinatarios] = useState(0);
  const [cargandoContador, setCargandoContador] = useState(false);
  const [enviandoCampana, setEnviandoCampana] = useState(false);

  // 3. CARGAR UNIVERSIDADES, CARRERAS Y PLANTILLAS AL INICIAR
  useEffect(() => {
    cargarUniversidades();
    cargarCarreras();
    obtenerPlantillas(nombreEmpresa);
  }, []);


  // Manejadores de cambio de selectores
  const handleSelectChange = (selectedOption, { name }) => {
    setCampaignData(prev => ({
      ...prev,
      [name]: selectedOption ? selectedOption.value : ''
    }));
  };

  // Manejador específico para cuando eligen una plantilla guardada
  const handlePlantillaChange = (selectedOption) => {
    setPlantillaSeleccionada(selectedOption);
    setCampaignData(prev => ({
      ...prev,
      plantilla_id: selectedOption ? selectedOption.value : ''
    }));
  };

  // 4. EFECTO DEBOUNCE MANTENIDO PARA CONTAR DESTINATARIOS
  useEffect(() => {
    const consultarDestinatarios = async () => {
        setCargandoContador(true);
        try {
        // 1. Guarda el resultado que RETORNA la función
        const datosFrescos = await obtenerDestinatarios(
            nombreEmpresa,
            campaignData.tipo,
            campaignData.universidad,
            campaignData.carrera
        );
        
        // 2. Usa esa variable directa para el contador (ya que es un array)
        if (datosFrescos && Array.isArray(datosFrescos)) {
            setContadorDestinatarios(datosFrescos.length);
        } else {
            setContadorDestinatarios(0);
        }

        } catch (error) {
        console.error("Error consultando contador:", error);
        } finally {
        setCargandoContador(false);
        }
    };

    const timeoutId = setTimeout(() => { consultarDestinatarios(); }, 400);
    return () => clearTimeout(timeoutId);
    }, [campaignData.tipo, campaignData.universidad, campaignData.carrera]);

  // 5. FUNCIÓN PARA ENVIAR LA CAMPAÑA CON LA PLANTILLA ASOCIADA
 // 5. FUNCIÓN PARA ENVIAR LA CAMPAÑA CON LA PLANTILLA ASOCIADA
  const handleEnviarCampana = async () => {
    if (!campaignData.nombre?.trim()) return alert("⚠️ Asigna un nombre a la campaña.");
    if (!campaignData.plantilla_id) return alert("⚠️ Selecciona una plantilla de la biblioteca.");
    if (contadorDestinatarios === 0) return alert("❌ No hay destinatarios válidos.");
    if (!window.confirm(`¿Enviar esta campaña masiva a ${contadorDestinatarios} personas?`)) return;

    setEnviandoCampana(true);

    // Preparamos el payload exacto que espera recibir el backend
    const payload = {
      nombreCampana: campaignData.nombre,
      tipo: campaignData.tipo,
      universidad: campaignData.universidad,
      carrera: campaignData.carrera,
      plantillaId: campaignData.plantilla_id 
    };

    try {
      // Invocamos el servicio del modelo que maneja Toasts y pantallas de carga automáticamente
      const resultado = await createCampana(nombreEmpresa, payload);
      
      if (resultado && resultado.success) {
        // Si la función callback existe (ej: para cambiar de pestaña al historial), la ejecuta
        if (onCampanaCreada) onCampanaCreada();
      }
    } catch (error) {
      console.error("Flujo de envío masivo detenido por error controlado en API.");
    } finally {
      setEnviandoCampana(false);
    }
  };

  return (
    <div className="grid grid-cols-1 xl:grid-cols-3 gap-6 animate-fadeIn text-sm">
      
      {/* SECCIÓN DE FILTROS (COLUMNA IZQUIERDA) */}
      <div className="bg-white p-5 rounded-xl shadow-sm border border-gray-100 space-y-4 h-fit">
        <div className="border-b pb-2">
          <h3 className="text-base font-bold text-gray-900">1. Segmentación de Audiencia</h3>
        </div>
        
        <div>
          <label className="block text-xs font-bold uppercase text-gray-500 mb-1">Nombre Campaña</label>
          <input type="text" name="nombre" value={campaignData.nombre || ''} onChange={(e) => setCampaignData({...campaignData, nombre: e.target.value})} placeholder="Ej: Promo Física UNAD" className="w-full px-3 py-1.5 border border-gray-300 rounded-md text-xs outline-none focus:ring-1 focus:ring-blue-500" />
        </div>

        <div>
          <label className="block text-xs font-bold uppercase text-gray-500 mb-1">Tipo Destinatario</label>
          <select name="tipo" value={campaignData.tipo || 'todos'} onChange={(e) => setCampaignData({...campaignData, tipo: e.target.value})} className="w-full px-3 py-1.5 border border-gray-300 rounded-md text-xs bg-white outline-none">
            <option value="todos">Todos (Clientes y Tutores)</option>
            <option value="clientes">Solo Clientes</option>
            <option value="tutores">Solo Tutores</option>
          </select>
        </div>

        <div>
          <label className="block text-xs font-bold uppercase text-gray-500 mb-1">Universidad</label>
           <Select
                name="universidad"
                value={campaignData.universidad ? { label: campaignData.universidad, value: campaignData.universidad } : null}
                onChange={handleSelectChange}
                options={universidadesOptions}
                placeholder="Selecciona una universidad"
                isClearable
                isSearchable
                isLoading={isLoadingUniversidad}
                loadingMessage={() => "Cargando universidades..."}
                noOptionsMessage={() => "No se encontraron universidades"}
                classNamePrefix="react-select"
                className="text-xs"
            />
        </div>

        <div>
          <label className="block text-xs font-bold uppercase text-gray-500 mb-1">Carrera</label>
          <Select
                name="carrera"
                value={campaignData.carrera ? { label: campaignData.carrera, value: campaignData.carrera } : null}
                onChange={handleSelectChange}
                options={carrerasOptions}
                placeholder="Selecciona una carrera"
                isClearable
                isSearchable
                isLoading={isLoadingCarreras}
                loadingMessage={() => "Cargando carreras..."}
                noOptionsMessage={() => "No se encontraron carreras"}
                classNamePrefix="react-select"
                className="text-xs"
            />
        </div>

        <div className="bg-blue-50 p-3 rounded-lg border border-blue-100">
          <span className="text-xs font-bold text-blue-800 uppercase">Destinatarios Alcanzados</span>
          <div className="flex items-center space-x-2 mt-0.5">
            {cargandoContador ? <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-900"></div> : <h3 className="text-xl font-black text-blue-900">{contadorDestinatarios} <span className="text-xs font-normal text-blue-700">correos</span></h3>}
          </div>
        </div>
      </div>

      {/* SECCIÓN DE CARGA DE PLANTILLAS Y PREVIEW (COLUMNAS DERECHAS) */}
      <div className="xl:col-span-2 bg-white p-5 rounded-xl shadow-sm border border-gray-100 flex flex-col justify-between min-h-[500px]">
        
        <div>
          <div className="border-b pb-2 mb-4">
            <h3 className="text-base font-bold text-gray-900">2. Vinculación de Contenido</h3>
            <p className="text-xs text-gray-400 mt-0.5">Asocia una plantilla prediseñada de tu biblioteca de PostgreSQL.</p>
          </div>

          <div className="mb-6 max-w-md">
            <label className="block text-xs font-bold uppercase text-gray-500 mb-1">Seleccionar Plantilla Guardada</label>
            <Select
              options={plantillasOptions}
              isLoading={Loadingplantillas}
              placeholder="Busca y selecciona un diseño..."
              onChange={handlePlantillaChange}
              isClearable
              loadingMessage={() => "Conectando con biblioteca..."}
              noOptionsMessage={() => "No tienes plantillas creadas todavía"}
              className="text-xs"
            />
          </div>

          {/* PREVISUALIZADOR INTEGRADO O MENSAJE DE ESPERA */}
          <div className="bg-gray-50 rounded-xl p-4 border border-gray-200 min-h-[320px] flex flex-col items-center justify-center">
            {plantillaSeleccionada ? (
              <WidgetPreviewPlantilla 
                bloques={plantillaSeleccionada?.json_data?.bloques} 
                asunto={plantillaSeleccionada?.json_data?.asunto} 
              />
            ) : (
              <div className="text-center text-gray-400 py-12">
                <svg className="w-12 h-12 mx-auto text-gray-300 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                </svg>
                <p className="text-xs font-medium">Ninguna plantilla vinculada todavía.</p>
                <p className="text-[11px] text-gray-400 mt-0.5">Elige un diseño del menú superior para cargar la previsualización.</p>
              </div>
            )}
          </div>

        </div>

        {/* ACCIONES INFERIORES */}
        <div className="mt-5 border-t pt-3 flex justify-end space-x-3">
          <button 
            onClick={handleEnviarCampana}
            disabled={enviandoCampana || !campaignData.plantilla_id}
            className={`px-5 py-1.5 bg-emerald-600 hover:bg-emerald-700 text-white rounded-md text-xs font-bold shadow-md transition-colors flex items-center space-x-2 ${
              enviandoCampana || !campaignData.plantilla_id ? 'opacity-50 cursor-not-allowed' : ''
            }`}
          >
            {enviandoCampana && <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-white mr-1"></div>}
            <span>{enviandoCampana ? 'Procesando Envío...' : '🚀 Despachar Campaña Masiva'}</span>
          </button>
        </div>

      </div>

    </div>
  );


};

export default NuevaCampaña;